define([
    "models/system/field",
    "models/system/model",
    "models/system/datasource",
    "models/system/commonView"
], function (Field, AbstractTableModel, Datasource, CommonView) {

    var endpoint = "ProjectReport";

    var model = new AbstractTableModel("ProjectReport", [
        {name: "id", header:APPLOCALE.reports.table.id,fillspace: false, viewLevel: 10, showInGrid: true},
        {
            name: "project_id",
            invalidMessage: APPLOCALE.errors.errorValidateEmpty,
            header: [APPLOCALE.card.table.project, {content: "serverSelectFilter"}],
            viewLevel: 10,
            minWidth: 140,
            adjust: "data",
            fillspace: false,
            type: "dictionary",
            dictionaryName: "Project",
            showInGrid: true
        },
        {
            name: "report_file",
            header: [APPLOCALE.reports.table.reportName,  {content: 'textFilter'}],
            label: APPLOCALE.reports.table.reportFileName,
            invalidMessage: APPLOCALE.errors.errorValidateEmptyForm,
            required: true,
            fillspace: false,
            view: "text",
            showInForm: true, showInGrid: true
        },
        {
            name: "report_ui_name",
            header: [APPLOCALE.reports.table.reportName,  {content: 'textFilter'}],
            label: APPLOCALE.reports.table.reportName,
            invalidMessage: APPLOCALE.errors.errorValidateEmptyForm,
            required: true,
            fillspace: false,
            view: "text",
            sort: "string",
            showInForm: true, showInGrid: true
        },
        {
            name: "visible_admin",
            header: APPLOCALE.reports.table.visibleAdmin,
            showInForm: true, showInGrid: true,fillspace: true,
            template:function(obj, common, value, config){
                var chbVal = (value === "Y")? 1 : 0;
                return common.checkbox(obj, common, chbVal, config);
            }
        },{
            name: "visible_enterprise_admin",
            minWidth: 140,
            header: APPLOCALE.reports.table.visibleAdminEnterprise,
            showInForm: true, showInGrid: true, fillspace: true,
            template:function(obj, common, value, config){
                var chbVal = (value === "Y")? 1 : 0;
                return common.checkbox(obj, common, chbVal, config);
            }
        }, {
            name: "visible_operator",
            header: APPLOCALE.reports.table.visibleOperator,
            showInForm: true, showInGrid: true,fillspace: true,
            template:function(obj, common, value, config){
                var chbVal = (value === "Y")? 1 : 0;
                return common.checkbox(obj, common, chbVal, config);
            }
        }, {
            name: "trans_card_visual",
            header: APPLOCALE.reports.table.walletVisible,
            showInForm: true, showInGrid: true,fillspace: true,
            template:function(obj, common, value, config){
                var chbVal = (value === "Y")? 1 : 0;
                return common.checkbox(obj, common, chbVal, config);
            }
        },{
            name: "espd_visual",
            header: APPLOCALE.reports.table.espdVisible,
            showInForm: true, showInGrid: true,fillspace: true,
            template:function(obj, common, value, config){
                var chbVal = (value === "Y")? 1 : 0;
                return common.checkbox(obj, common, chbVal, config);
            }
        },{
            name: "lpd_visual",
            header: APPLOCALE.reports.table.lpdVisible,
            showInForm: true, showInGrid: true,fillspace: true,
            template:function(obj, common, value, config){
                var chbVal = (value === "Y")? 1 : 0;
                return common.checkbox(obj, common, chbVal, config);
            }
        },{
            name: "qr_visual",
            header: APPLOCALE.reports.table.qrVisible,
            showInForm: true, showInGrid: true,fillspace: true,
            template:function(obj, common, value, config){
                var chbVal = (value === "Y")? 1 : 0;
                return common.checkbox(obj, common, chbVal, config);
            }
        },{
            name: "rv_visual",
            header: APPLOCALE.reports.table.rvVisible,
            showInForm: true, showInGrid: true,fillspace: true,
            template:function(obj, common, value, config){
                var chbVal = (value === "Y")? 1 : 0;
                return common.checkbox(obj, common, chbVal, config);
            }
        },{
            name: "isactive",
            header: APPLOCALE.reports.table.isactive,
            type: "toggle", toggleName: "yesno",
            adjust: "header",
            sort: "string",
            showInGrid: false
        }, {
            name: "troika_visual",
            header: APPLOCALE.reports.table.troikaVisible,
            showInForm: true, showInGrid: true,fillspace: true,
            template:function(obj, common, value, config){
                var chbVal = (value === "Y")? 1 : 0;
                return common.checkbox(obj, common, chbVal, config);
            }
        }
    ], endpoint);

    var dataSource = new Datasource(model);

    var view = new CommonView(dataSource);

    return {
        getModel: function () {
            return model;
        },
        getDatasource: function () {
            return dataSource;
        },
        getCommonViewModel: function () {
            return view;
        }
    };
});
